class IndexedDBLocalStorage {
  private readonly dbName: string;
  private readonly storeName: string;
  private db: IDBDatabase | null = null;

  constructor(dbName: string = 'localStorage', storeName: string = 'keyValue') {
    this.dbName = dbName;
    this.storeName = storeName;
  }

  private openDatabase(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, 1);
      request.onerror = (event) => {
        console.error('IndexedDB:', event.target['error']);
        reject(false);
      };
      request.onsuccess = (event) => {
        this.db = event.target['result'];
        resolve(true);
      };
      request.onupgradeneeded = (event) => {
        this.db = event.target['result'];
        this.db.createObjectStore(this.storeName);
        resolve(true);
      };
    });
  }

  private async getObjectStore(mode: IDBTransactionMode): Promise<IDBObjectStore> {
    if (!this.db) {
      await this.openDatabase();
    }
    const transaction = this.db.transaction(this.storeName, mode);
    return transaction.objectStore(this.storeName);
  }

  setItem(key: string, value: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      const store = await this.getObjectStore('readwrite');
      const request = store.put(value, key);
      request.onsuccess = () => resolve();
      request.onerror = (event) => reject(event.target['error']);
    });
  }

  getItem(key: string): Promise<string | null> {
    return new Promise<string | null>(async (resolve, reject) => {
      const store = await this.getObjectStore('readonly');
      const request = store.get(key);
      request.onsuccess = () => resolve(request.result);
      request.onerror = (event) => reject(event.target['error']);
    });
  }

  removeItem(key: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      const store = await this.getObjectStore('readwrite');
      const request = store.delete(key);
      request.onsuccess = () => resolve();
      request.onerror = (event) => reject(event.target['error']);
    });
  }

  clear(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      const store = await this.getObjectStore('readwrite');
      const request = store.clear();
      request.onsuccess = () => resolve();
      request.onerror = (event) => reject(event.target['error']);
    });
  }
}

export default IndexedDBLocalStorage;
